import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SystemApiService } from '@cv-invision/core';
import { EditableTableService } from '../../components/tables/editable-table/service/editable-table.service';

@Injectable({
	providedIn: 'root'
})
export class GenericService extends EditableTableService {
	public integrationId: string;
	public entity: string;
	public readonly BASE_URL = '/utils/integrations';

	constructor(public httpClient: HttpClient, public systemApiService: SystemApiService) {
        super(httpClient, systemApiService);
	}

	/**
     * Set configuration
     * @param integrationId 
     */
	setConfiguration(integrationId: string, entity: string): EditableTableService {
		this.integrationId = integrationId;
		this.entity        = entity;
		return this;
	}

	/**
	 * Get Data
	 */
	getData(): Observable<any> {
		return this.httpClient.get(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.integrationId}/${this.entity}`);
	}

	/**
	 * PUT - Save the configuration.
	 */
	saveData(data: Array<any>): Observable<any> {
		return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.integrationId}/${this.entity}`, data);
	}
}
